import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toastrService: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const ignoredMessages = new Set(['Неверный SMS-код!', 'Неверный SMS-код']);
        const errorMessage = error.error?.msg || error.error?.message || error.error || error.statusText;

        switch (error.status) {
          case 500:
            this.toastrService.error('internal server error 500!');
            break;
          case 522:
            this.toastrService.error(error.error?.msg || error.error || error.statusText);
            break;
          case 422:
            // dont show error message for invalid sms code in owner phone verification
            if (!ignoredMessages.has(errorMessage)) {
              this.toastrService.warning(errorMessage);
            }
            break;
          case 404:
          case 403:
          case 400:
            this.toastrService.warning(errorMessage);
            break;
        }
        return throwError(() => error);
      })
    );
  }
}
